import { forwardRef, type ButtonHTMLAttributes } from "react";

import { cx } from "./cx";
import styles from "./icon-button.module.css";

type Size = "sm" | "md" | "lg" | "xl";
type Tone = "neutral" | "danger";
type Appearance = "plain" | "solid" | "overlay";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: Size;
  tone?: Tone;
  appearance?: Appearance;
  "aria-label": string;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      className,
      size = "md",
      tone = "neutral",
      appearance = "plain",
      type = "button",
      ...props
    },
    ref,
  ) => (
    <button
      ref={ref}
      type={type}
      className={cx(
        styles.iconButton,
        styles[size],
        styles[tone],
        styles[appearance],
        className,
      )}
      {...props}
    />
  ),
);

IconButton.displayName = "IconButton";
